import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";
import { Button, Col, Modal, ModalBody, ModalFooter,  Row } from "reactstrap";
import MedicalPdfPreview from "./MedicalPdfPreview";
import { isPdfResultFile } from "./result-files";
import ModalHeader from "@dhn/components/molecules/modal-header";
import "./medical-results.scss";

export default function MedicalFilesViewerModal({
  isOpen,
  toggle,
  title,
  files,
  currentIndex,
  onPrev,
  onNext,
  onDeleteCurrent,
  canDelete = false,
  isLoading,
  errorMessage,
  emptyTitle = "Archivos del Resultado",
}) {
  const { addToast } = useToasts();
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const hasFiles = Array.isArray(files) && files.length > 0;
  const currentFile = hasFiles ? files[currentIndex] : null;
  const isCurrentFilePdf = isPdfResultFile(currentFile);

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader
        toggle={toggle}
        iconClass="fa-file-o"
        description={title || emptyTitle}
        subtitle="Revise los archivos del resultado."
      />
      <ModalBody>
        {isLoading ? <Row><Col className="text-center text-muted py-5">Cargando archivos...</Col></Row> : null}
        {!isLoading && errorMessage ? <Row><Col className="text-center text-danger py-4">{errorMessage}</Col></Row> : null}
        {!isLoading && !errorMessage && !hasFiles ? <Row><Col className="text-center text-muted py-5">No hay archivos disponibles.</Col></Row> : null}
        {!isLoading && !errorMessage && currentFile ? (
          <>
            <div className={`medical-results-preview${isCurrentFilePdf ? " medical-results-preview--pdf" : ""}`}>
              {isCurrentFilePdf ? (
                <MedicalPdfPreview
                  source={currentFile.previewUrl}
                  title={currentFile.originalName}
                />
              ) : (
                <img src={currentFile.previewUrl} alt={currentFile.originalName || "resultado"} />
              )}
            </div>
            <div className="text-center text-muted mt-2">
              {`${currentIndex + 1} de ${files.length} - ${currentFile.originalName || "archivo"}`}
            </div>
          </>
        ) : null}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <div>
          <Button type="button" color="danger" className="btn-color-danger mr-2" onClick={toggle}>
            <i className="fa fa-times" />{" Cerrar"}
          </Button>
          {canDelete ? (
            <Button type="button" color="danger" className="btn-color-danger mr-2" onClick={() => setIsConfirmDeleteOpen(true)} disabled={isLoading || !hasFiles}>
              <i className="fa fa-trash" />{" Borrar"}
            </Button>
          ) : null}
        </div>
        <div>
          <Button type="button" color="info" className="btn-color-primary mr-2" onClick={onPrev} disabled={isLoading || !hasFiles || files.length <= 1}>
            <i className="fa fa-angle-left" />{" Anterior"}
          </Button>
          <Button type="button" color="info" className="btn-color-primary" onClick={onNext} disabled={isLoading || !hasFiles || files.length <= 1}>
            <i className="fa fa-angle-right" />{" Siguiente"}
          </Button>
        </div>
      </ModalFooter>

      <Modal centered isOpen={isConfirmDeleteOpen} toggle={() => setIsConfirmDeleteOpen(false)}>
        <ModalHeader
          toggle={() => setIsConfirmDeleteOpen(false)}
          iconClass="fa-trash"
          iconVariant="danger"
          description="Borrar archivo"
          subtitle="Confirme si desea borrar el archivo seleccionado."
        />
        <ModalBody>¿Está seguro de que desea borrar este archivo?</ModalBody>
        <ModalFooter>
          <Button type="button" color="danger" className="btn-color-danger" onClick={() => {
            if ((files || []).length <= 1) {
              setIsConfirmDeleteOpen(false);
              addToast("Debe guardar por lo menos un archivo.", { appearance: "error", autoDismiss: true });
              return;
            }
            setIsConfirmDeleteOpen(false);
            onDeleteCurrent();
          }}>
            <i className="fa fa-trash" />{" Borrar"}
          </Button>
          <Button color="danger" className="btn-color-danger" type="button" onClick={() => setIsConfirmDeleteOpen(false)}>
            <i className="fa fa-times" />{" Cancelar"}
          </Button>
        </ModalFooter>
      </Modal>
    </Modal>
  );
}
